module.exports = __webpack_public_path__ + "img/zf_1@2x.3d15d474.png";